import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MANIFEST_LINK_ID = "pwa-manifest-link";

function getManifestHref(): string {
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
  const isMacSafari =
    /Macintosh/.test(ua) &&
    /Safari/.test(ua) &&
    !/Chrome|Chromium|Edg|Opera/.test(ua);
  return isIOS || isMacSafari ? "./manifest.json" : "/manifest.json";
}

function attachManifest(): void {
  if (document.getElementById(MANIFEST_LINK_ID)) return;
  const link = document.createElement("link");
  link.rel = "manifest";
  link.id = MANIFEST_LINK_ID;
  link.href = getManifestHref();
  document.head.appendChild(link);
}

function detachManifest(): void {
  const existing = document.getElementById(MANIFEST_LINK_ID);
  if (existing) existing.remove();
}

function usePwaManifest(): void {
  const { pathname } = useLocation();
  const isDashboard = pathname.startsWith("/control-panel");

  useEffect(() => {
    if (isDashboard) attachManifest();
    else detachManifest();
  }, [isDashboard]);
}

export default usePwaManifest;
